import React from 'react';
import { Alert, AlertDescription } from '../../../ui/alert';
import { CheckCircle2, PenLine } from 'lucide-react';
import { format } from 'date-fns';

interface AttestationAlertProps {
    attested?: boolean;
    attestationName?: string;
    signOffDate?: string;
    pendingSignerName?: string;
}

export function AttestationAlert({
    attested,
    attestationName,
    signOffDate,
    pendingSignerName,
}: AttestationAlertProps) {
    if (!attested) {
        if (!pendingSignerName) return null;

        return (
            <Alert className="rounded-xl border-amber-500/30 bg-amber-500/[0.08] text-foreground shadow-sm">
                <PenLine className="h-4 w-4 text-amber-600 dark:text-amber-300" />
                <AlertDescription className="text-amber-800 dark:text-amber-100/90">
                    Signature requested from {pendingSignerName}
                </AlertDescription>
            </Alert>
        );
    }

    const isDateOnly =
        typeof signOffDate === 'string' &&
        /^\d{4}-\d{2}-\d{2}$/.test(signOffDate);
    const dateDisplay = signOffDate
        ? format(new Date(signOffDate), isDateOnly ? 'PPP' : "PPP 'at' p")
        : format(new Date(), "PPP 'at' p");

    return (
        <Alert className="rounded-xl border-emerald-500/30 bg-emerald-500/[0.08] text-foreground shadow-sm">
            <CheckCircle2 className="h-4 w-4 text-emerald-600 dark:text-emerald-300" />
            <AlertDescription className="text-emerald-800 dark:text-emerald-100/90">
                Case documentation signed by {attestationName || 'User'} on{' '}
                {dateDisplay}
            </AlertDescription>
        </Alert>
    );
}
